import { useEffect, useState } from "react";
import { useDocument } from "react-firebase-hooks/firestore";
import { db } from "@poseidon/firebase/firebase";

import { doc } from "firebase/firestore";

export const useAgreement = ({ agreementId }) => {
  const [agreement, setAgreement] = useState();
  const [value, loading, error] = useDocument(
    doc(db, "agreements", agreementId),
    {
      snapshotListenOptions: { includeMetadataChanges: true },
    }
  );
  useEffect(() => {
    const run = async () => {
      if (value) {
        setAgreement({ id: value.id, ...value.data() });
      }
    };
    run();
  }, [value, agreementId]);

  return { agreement, loading, error };
};
